import { render, staticRenderFns } from "./CobranzaSeguroCelular.vue?vue&type=template&id=19219043"
import script from "./CobranzaSeguroCelular.vue?vue&type=script&lang=js"
export * from "./CobranzaSeguroCelular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports